module.exports = __webpack_public_path__ + "img/svg/trophy-lost.d15413ca3e8019b38fe397c5f8831ea7.svg";